// extracted by mini-css-extract-plugin
export var portfolio = "portfolio-module--portfolio--bi8z4";
export var portfolioItem = "portfolio-module--portfolio-item--K68tC";